import { render, staticRenderFns } from "./cocal-port-list.vue?vue&type=template&id=54fd5263&scoped=true&"
import script from "./cocal-port-list.vue?vue&type=script&lang=js&"
export * from "./cocal-port-list.vue?vue&type=script&lang=js&"
import style0 from "./cocal-port-list.vue?vue&type=style&index=0&id=54fd5263&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fd5263",
  null
  
)

export default component.exports